import { Group } from '@mantine/core';
import { IAutomationSetFileName } from 'pages/revisions-module/template-editor/editors/pipeline/types';
import P3Medium from 'components/typography/P3Medium';
import P3Regular from 'components/typography/P3Regular';
import InputMention from 'pages/revisions-module/template-editor/editors/InputMention';

/**
 * The automation preview for set-file-name automation.
 */
export default function SetFileNameAutomationPreview({ data }: { data: IAutomationSetFileName }) {
  return (
    <Group spacing={4}>
      <P3Medium>Názov PDF súboru:</P3Medium>
      <P3Regular>
        {data.timestampPrefix && <span>{'<timestamp>-'}</span>}
        <InputMention prefix="Podľa poľa" name={data.inputName} />
      </P3Regular>
    </Group>
  );
}
